import { getAllOrganizationTimesRef, getOrganizationRef, getParentOrganizationsRef, getOrganizationBySlugRef, getOrganizationStatsRef, checkOrganizationSlugRef, updateOrganizationRef, updateOrganizationProvidersRef, createOrganizationRef, softDeleteOrganizationRef, getLatestInboxMessagesRef, getMessagesByPhoneIdRef, markMessagesProcessedRef, markMessageFollowUpRef, markMessagesUnprocessedRef, markThreadFollowUpRef, addViewerRef, getScheduleRef, getScheduleByIdRef, createScheduleRef, updateScheduleRef, softDeleteScheduleRef, markScheduleAsSendNowRef, listSpecialMessagesRef, listPublicSpecialMessagesRef, upsertSpecialMessageRef, saveTokenRef, deleteTokenRef, getTokensRef, getTokensByOrganizationRef, meRef, getUserByEmailRef, upsertUserRef, softDeleteUserRef, saveClientNotificationTokenRef, deleteClientNotificationTokenRef, getClientNotificationTokensRef, getClientNotificationTokensByTargetRef, getContentListRef, getContentRef, addContentRef, updateContentRef, softDeleteContentRef, createLoginCodeRef, incrementLoginCodeAttemptsRef, deleteLoginCodeRef, getLoginCodeByEmailRef, clearLoginCodesRef, getMembersRef, getMemberRef, getMemberReferencesRef, getMemberByEmailRef, addMemberRef, updateMemberRef, softDeleteMemberRef, softDeleteMembersByOrganizationRef, getMiscSettingRef, upsertMiscSettingRef, getOrganizationByPhoneRef, getPhoneByNumberRef, getMemberByPhoneRef, getMemberByTextRef, getPhonesRef, getPhoneRef, getAdminPhoneRef, getPhoneWithMessagesRef, createPhoneRef, updatePhoneRef, addPhoneNotesRef, deletePhoneNotesRef, undeletePhoneRef, createPhoneMessageRef, updatePhoneMessageProcessedRef, getPhoneNumbersRef, getPhoneNumberRef, getPhoneNumberOrganizationsRef, addPhoneNumberRef, verifyPhoneNumberRef, assignPhoneNumberRef, unassignPhoneNumberRef, getUserRightsRef, getAdminUserRightsRef, getRightsByOrganizationRef, getInvitationsByOrganizationRef, getInvitationsByEmailRef, upsertRightsRef, deleteRightsRef, addInvitationRef, deleteInvitationRef, acceptInvitationRef } from '../../';
import { DataConnect, CallerSdkTypeEnum } from '@angular/fire/data-connect';
import { injectDataConnectQuery, injectDataConnectMutation } from '@tanstack-query-firebase/angular/data-connect';
import { inject, EnvironmentInjector } from '@angular/core';
export function injectGetAllOrganizationTimes(options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getAllOrganizationTimesRef(dc),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetOrganization(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getOrganizationRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetParentOrganizations(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getParentOrganizationsRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetOrganizationBySlug(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getOrganizationBySlugRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetOrganizationStats(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getOrganizationStatsRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectCheckOrganizationSlug(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  checkOrganizationSlugRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectUpdateOrganization(args, injector) {
  return injectDataConnectMutation(updateOrganizationRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectUpdateOrganizationProviders(args, injector) {
  return injectDataConnectMutation(updateOrganizationProvidersRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectCreateOrganization(args, injector) {
  return injectDataConnectMutation(createOrganizationRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectSoftDeleteOrganization(args, injector) {
  return injectDataConnectMutation(softDeleteOrganizationRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetLatestInboxMessages(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getLatestInboxMessagesRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetMessagesByPhoneId(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getMessagesByPhoneIdRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectMarkMessagesProcessed(args, injector) {
  return injectDataConnectMutation(markMessagesProcessedRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectMarkMessageFollowUp(args, injector) {
  return injectDataConnectMutation(markMessageFollowUpRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectMarkMessagesUnprocessed(args, injector) {
  return injectDataConnectMutation(markMessagesUnprocessedRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectMarkThreadFollowUp(args, injector) {
  return injectDataConnectMutation(markThreadFollowUpRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectAddViewer(args, injector) {
  return injectDataConnectMutation(addViewerRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetSchedule(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getScheduleRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetScheduleById(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getScheduleByIdRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectCreateSchedule(args, injector) {
  return injectDataConnectMutation(createScheduleRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectUpdateSchedule(args, injector) {
  return injectDataConnectMutation(updateScheduleRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectSoftDeleteSchedule(args, injector) {
  return injectDataConnectMutation(softDeleteScheduleRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectMarkScheduleAsSendNow(args, injector) {
  return injectDataConnectMutation(markScheduleAsSendNowRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectListSpecialMessages(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  listSpecialMessagesRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectListPublicSpecialMessages(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  listPublicSpecialMessagesRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectUpsertSpecialMessage(args, injector) {
  return injectDataConnectMutation(upsertSpecialMessageRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectSaveToken(args, injector) {
  return injectDataConnectMutation(saveTokenRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectDeleteToken(args, injector) {
  return injectDataConnectMutation(deleteTokenRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetTokens(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getTokensRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetTokensByOrganization(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getTokensByOrganizationRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectMe(options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  meRef(dc),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetUserByEmail(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getUserByEmailRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectUpsertUser(args, injector) {
  return injectDataConnectMutation(upsertUserRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectSoftDeleteUser(args, injector) {
  return injectDataConnectMutation(softDeleteUserRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectSaveClientNotificationToken(args, injector) {
  return injectDataConnectMutation(saveClientNotificationTokenRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectDeleteClientNotificationToken(args, injector) {
  return injectDataConnectMutation(deleteClientNotificationTokenRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetClientNotificationTokens(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getClientNotificationTokensRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetClientNotificationTokensByTarget(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getClientNotificationTokensByTargetRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetContentList(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getContentListRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetContent(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getContentRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectAddContent(args, injector) {
  return injectDataConnectMutation(addContentRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectUpdateContent(args, injector) {
  return injectDataConnectMutation(updateContentRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectSoftDeleteContent(args, injector) {
  return injectDataConnectMutation(softDeleteContentRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectCreateLoginCode(args, injector) {
  return injectDataConnectMutation(createLoginCodeRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectIncrementLoginCodeAttempts(args, injector) {
  return injectDataConnectMutation(incrementLoginCodeAttemptsRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectDeleteLoginCode(args, injector) {
  return injectDataConnectMutation(deleteLoginCodeRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetLoginCodeByEmail(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getLoginCodeByEmailRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectClearLoginCodes(args, injector) {
  return injectDataConnectMutation(clearLoginCodesRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetMembers(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getMembersRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetMember(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getMemberRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetMemberReferences(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getMemberReferencesRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetMemberByEmail(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getMemberByEmailRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectAddMember(args, injector) {
  return injectDataConnectMutation(addMemberRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectUpdateMember(args, injector) {
  return injectDataConnectMutation(updateMemberRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectSoftDeleteMember(args, injector) {
  return injectDataConnectMutation(softDeleteMemberRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectSoftDeleteMembersByOrganization(args, injector) {
  return injectDataConnectMutation(softDeleteMembersByOrganizationRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetMiscSetting(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getMiscSettingRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectUpsertMiscSetting(args, injector) {
  return injectDataConnectMutation(upsertMiscSettingRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetOrganizationByPhone(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getOrganizationByPhoneRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetPhoneByNumber(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getPhoneByNumberRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetMemberByPhone(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getMemberByPhoneRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetMemberByText(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getMemberByTextRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetPhones(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getPhonesRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetPhone(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getPhoneRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetAdminPhone(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getAdminPhoneRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetPhoneWithMessages(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getPhoneWithMessagesRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectCreatePhone(args, injector) {
  return injectDataConnectMutation(createPhoneRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectUpdatePhone(args, injector) {
  return injectDataConnectMutation(updatePhoneRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectAddPhoneNotes(args, injector) {
  return injectDataConnectMutation(addPhoneNotesRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectDeletePhoneNotes(args, injector) {
  return injectDataConnectMutation(deletePhoneNotesRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectUndeletePhone(args, injector) {
  return injectDataConnectMutation(undeletePhoneRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectCreatePhoneMessage(args, injector) {
  return injectDataConnectMutation(createPhoneMessageRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectUpdatePhoneMessageProcessed(args, injector) {
  return injectDataConnectMutation(updatePhoneMessageProcessedRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetPhoneNumbers(options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getPhoneNumbersRef(dc),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetPhoneNumber(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getPhoneNumberRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetPhoneNumberOrganizations(options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getPhoneNumberOrganizationsRef(dc),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectAddPhoneNumber(args, injector) {
  return injectDataConnectMutation(addPhoneNumberRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectVerifyPhoneNumber(args, injector) {
  return injectDataConnectMutation(verifyPhoneNumberRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectAssignPhoneNumber(args, injector) {
  return injectDataConnectMutation(assignPhoneNumberRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectUnassignPhoneNumber(args, injector) {
  return injectDataConnectMutation(unassignPhoneNumberRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetUserRights(options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getUserRightsRef(dc),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetAdminUserRights(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getAdminUserRightsRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetRightsByOrganization(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getRightsByOrganizationRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetInvitationsByOrganization(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getInvitationsByOrganizationRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectGetInvitationsByEmail(args, options, injector) {
  const finalInjector = injector || inject(EnvironmentInjector);
  const dc = finalInjector.get(DataConnect);
  const varsFactoryFn = (typeof args === 'function') ? args : () => args;
  return injectDataConnectQuery(() => {
    const addOpn = options && options();
    return {
      queryFn: () =>  getInvitationsByEmailRef(dc, varsFactoryFn()),
      ...addOpn
    };
  }, finalInjector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectUpsertRights(args, injector) {
  return injectDataConnectMutation(upsertRightsRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectDeleteRights(args, injector) {
  return injectDataConnectMutation(deleteRightsRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectAddInvitation(args, injector) {
  return injectDataConnectMutation(addInvitationRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectDeleteInvitation(args, injector) {
  return injectDataConnectMutation(deleteInvitationRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

export function injectAcceptInvitation(args, injector) {
  return injectDataConnectMutation(acceptInvitationRef, args, injector, CallerSdkTypeEnum.GeneratedAngular);
}

